import { notification } from 'antd';
import { AxiosError } from 'axios';
import Axios from '../../../axios/axios';

export const createDirector =
    (
        email: string,
        name: string,
        lastName: string,
        workPosition: string,
        phone: string,
        password: string,
        companyId: number,
    ) =>
    async (dispatch) => {
        dispatch({
            type: 'LOADING_DIRECTOR',
            payload: true,
        });

        try {
            await Axios.post('/users', {
                email,
                name,
                lastName,
                photo: 'uri',
                passwd: password,
                phone,
                workPosition,
                companyId,
            });

            notification.success({
                message: 'Administrador creado.',
                description: '¡El administrador ha sido creado exitosamente!',
            });
        } catch (error) {
            const err = error as AxiosError;
            console.log(err.response?.data);
            notification.error({
                message: 'Supervisor no creado.',
                description: '¡El administrador no ha sido creado!',
            });
        } finally {
            dispatch({
                type: 'LOADING_DIRECTOR',
                payload: false,
            });
        }
    };
